// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-edit-task-deadline .task-edit-controls-container .fi-date-picker {
  width: 100%;
  margin-top: 20px;
}
.fi-task-edit-task-deadline .task-edit-controls-container .fi-date-picker .mat-mdc-form-field-icon-suffix {
  margin-right: 10px;
}
.fi-task-edit-task-deadline .task-edit-controls-container .fi-date-picker .mat-datepicker-toggle .mat-mdc-icon-button.mat-mdc-button-base svg {
  width: 24px;
  height: 24px;
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-task-shared/task-edit/task-edit-task/task-edit-task-deadline/task-edit-task-deadline.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,gBAAA;AAAR;AACQ;EACI,kBAAA;AACZ;AACQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACZ","sourcesContent":[".fi-task-edit-task-deadline {\r\n    .task-edit-controls-container .fi-date-picker {\r\n        width: 100%;\r\n        margin-top: 20px;\r\n        .mat-mdc-form-field-icon-suffix {\r\n            margin-right: 10px;\r\n        }\r\n        .mat-datepicker-toggle .mat-mdc-icon-button.mat-mdc-button-base svg {\r\n            width: 24px;\r\n            height: 24px;\r\n            color: #6b7280;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
